import styled from "@emotion/styled"
import { FetchMenusQuery } from "apollo"
import DesktopNavlink from "layout/DesktopNavLink"
import { StyledList } from "layout/SideMenu"
import Image from "next/image"
import Link from "next/link"
import { usePathname } from "next/navigation"
import PazChargeLogo from "public/icons/pazCharge/Logo/Logo.svg"
import { TrackMapSource, trackEventByNameAndCategory, trackTopBarLinkClicked } from "reusable/ChargeGTM"
import { sharedColors } from "ui/theme/colors"
import { extractMenuProperties } from "utils"
import { getNonUmbracoURL } from "utils/utils"

const StyledListHeader = styled(StyledList)`
  margin-inline-end: auto;
  display: flex;
  height: 98px;
  overflow-y: hidden;
  box-sizing: border-box;
  margin: 0px;
  gap: 10px;
  ${(props) => props.theme.breakpoints.up("md")} {
      justify-content: space-evenly;
      gap: 0px;
      & > * {
        flex-grow: 1;
        padding: 0 4px;
      }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    gap: 20px;
  }
`
const StyledLink = styled(Link) <{ selected?: boolean }>`
  display: flex;
    ${(props) => props.theme.breakpoints.only("md")} {
    padding: 0px;
  }
`
const StyledRelative = styled.header`
  @media print {
    display: none;
  }
  position: relative;
  z-index: 30;
`
const StyledHeader = styled.div`
  position: fixed;
  z-index: 100001;
  top: 0px;
  left: 0px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  height: 64px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
  box-shadow: 0px 2px 8px 0px rgba(130, 136, 148, 0.25);

  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    height: 98px;
    padding: 0;
  }
`
const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  align-items: center;
  padding: 0;
  gap: 15px;
    & > :first-child {
    flex: 1;
  }
  padding-left: 20px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 100px;
    padding-right: 100px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 300px;
    padding-right: 300px
  }
`
const StyledLinkInButton = styled(Link)`
  background-color: ${sharedColors.blue};
  border-radius: 40px;
  text-decoration: none;
  color: white;
  text-align: center;
  padding: 16px;
  min-width: fit-content;
  font-size: 18px;
  line-height: 20px;
  font-weight: 500;
`

const StyledLogoAndNav = styled.div`
  display: flex;
  align-items: center;
 nav {
     flex-grow: 1;
  }
  gap: 10px;
`

function DesktopHeader({
  data,
}: {
  locale: string
  data: FetchMenusQuery
}) {
  const pathname = usePathname()

  const menuDesktop = data?.menu_desktop?.nodes
  return (
    <StyledRelative role="banner">
      <StyledHeader>
        <StyledContainer>
          <StyledLogoAndNav>
            <StyledLink
              href={"/pazcharge"}
              id="desktopLogoHeader"
            >
              <Image
                src={PazChargeLogo}
                alt="פז charge לעמוד הבית"
                width={200}
                height={70}
              // priority
              />
            </StyledLink>
            <nav>
              <StyledListHeader>
                {menuDesktop?.map((item: any, index: number) => {
                  const { title, url, blank } = extractMenuProperties(item)
                  return (
                    <DesktopNavlink
                      blank={blank}
                      key={index.toString()}
                      href={getNonUmbracoURL(url)}
                      selected={
                        decodeURI(pathname) + "/" === getNonUmbracoURL(url) ||
                        decodeURI(pathname) === getNonUmbracoURL(url)
                      }
                      title={title}
                      subCategories={item?.children}
                      onClick={() => {
                        trackTopBarLinkClicked(title)
                      }}
                      index={index}
                    />
                  )
                })}
              </StyledListHeader>
            </nav>
          </StyledLogoAndNav>
          <StyledLinkInButton
            aria-label="למפת עמדות טעינה"
            href={"/pazcharge/charging-stations-map"}
            onClick={() => trackEventByNameAndCategory('open_map', TrackMapSource.HEADER)}
          >
            למפת עמדות טעינה
          </StyledLinkInButton>
        </StyledContainer>
      </StyledHeader>
    </StyledRelative>
  )
}

export default DesktopHeader
